import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';
import { login, logout, checkAuth as checkAuthRequest } from '../auth';
import { setUnauthorizedHandler } from '../api/client';

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
    const [isAuthenticated, setIsAuthenticated] = useState(false);
    const [role, setRole] = useState(null);
    const [loading, setLoading] = useState(true);

    const checkAuth = useCallback(async () => {
        try {
            const data = await checkAuthRequest();
            setIsAuthenticated(!!data.isAuthenticated);
            setRole(data.role || null);
        } catch {
            setIsAuthenticated(false);
            setRole(null);
        } finally {
            setLoading(false);
        }
    }, []);

    useEffect(() => {
        // Drop authenticated state whenever any request comes back 401.
        setUnauthorizedHandler(() => {
            setIsAuthenticated(false);
            setRole(null);
        });
        checkAuth();
    }, [checkAuth]);

    const handleLogin = async (username, password) => {
        try {
            await login(username, password);
            await checkAuth();
        } catch (error) {
            setIsAuthenticated(false);
            throw error;
        }
    };

    const handleLogout = async () => {
        await logout();
        setIsAuthenticated(false);
        setRole(null);
    };

    return (
        <AuthContext.Provider
            value={{
                isAuthenticated,
                role,
                isSuperAdmin: role === 'superadmin',
                loading,
                handleLogin,
                handleLogout,
                checkAuth,
            }}
        >
            {children}
        </AuthContext.Provider>
    );
};

export const useAuth = () => {
    return useContext(AuthContext);
};
